import Unit from './index';

export default class ProntoUnit extends Unit {

    upload = (date, cbSuccess, cbError) => {
        this.post(`/pronto/upload`, { date }, cbSuccess, cbError);
    }
}